export const environment = {
  production: true,
  apiUrl: 'https://api.resilienceenablers.com/',
  keycloakConfig: {
    url: 'https://auth.resilienceenablers.com',
    realm: 'ENABLE',
    clientId: 'web_app',
  },
};
